import { BaseViewModel } from "../../common/BaseViewModel";
import * as Format from "../../common/FormatFunctions";
import { CloudService } from "../../common/CloudService/ClientLibsReference";
import * as ApiService from "../../common/CloudService/ApiService";
import { CrudlStatus } from "../../common/config/AppConstants";
import * as UIMap from "../../common/PrimeComponents";
import * as Storage from "../../common/config/Storage";

export class SupplierViewModel extends BaseViewModel {
  showLoadingScreen = () => {
    this.updateState("loaded", false);
  };

  hideLoadingScreen = () => {
    this.updateState("loaded", true);
  };

  getSuppliers = async () => {
    //CRITICAL - ERROR + EMPTY MESSAGE
    var supplierResponse = await this.getSupplierListByCodeTag();
    if (
      Format.isNotNull(supplierResponse.errorCode) &&
      supplierResponse.errorCode === 0
    ) {
      if (Format.isNotNull(supplierResponse.businesses)) {
        this.updateState("supplierList", supplierResponse.businesses);
        this.logger.info(supplierResponse.businesses);
      } else {
        this.showEmpty("Supplier");
      }
    } else {
      this.showError("Supplier", CrudlStatus.LIST);
    }
  };

  getSuppliersReturned = async () => {
    //CRITICAL - ERROR + EMPTY MESSAGE
    var supplierResponse = await this.getSupplierListByCodeTag();
    if (
      Format.isNotNull(supplierResponse.errorCode) &&
      supplierResponse.errorCode === 0
    ) {
      if (Format.isNotNull(supplierResponse.supplierList)) {
        this.logger.info(supplierResponse.supplierList);
        return supplierResponse.supplierList;
      } else {
        this.showEmpty("Supplier");
      }
    } else {
      this.showError("Supplier", CrudlStatus.LIST);
    }
  };

  reloadDataAfterExecute = (
    suppliers,
    apiResponse,
    type,
    externalStateValues
  ) => {
    var updatedSupplierList = [];
    if (type === CrudlStatus.CREATE) {
      updatedSupplierList = this.reloadAfterCreate(
        suppliers,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.UPDATE) {
      updatedSupplierList = this.reloadAfterUpdate(
        suppliers,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.DELETE) {
      updatedSupplierList = this.reloadAfterDelete(
        suppliers,
        apiResponse,
        externalStateValues
      );
    }

    this.updateState("supplierList", updatedSupplierList);
  };

  reloadAfterCreate = (supplierList, apiResponse, externalStateValues) => {
    if (supplierList === undefined || supplierList === null) {
      supplierList = [];
    }
    var supplierBean = externalStateValues.supplierBean;
    supplierBean.id = apiResponse.id;
    supplierBean.lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;

    supplierList.push(supplierBean);

    return supplierList;
  };

  reloadAfterUpdate = (supplierList, apiResponse, externalStateValues) => {
    var i = 0;
    supplierList.forEach(e => {
      if (apiResponse.id === e.id) {
        supplierList[i] = externalStateValues.supplierBean;
        supplierList[i].lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;
      }
      i++;
    });

    return supplierList;
  };

  reloadAfterDelete = (supplierList, apiResponse, externalStateValues) => {
    var i = 0;
    supplierList.forEach(e => {
      //DELETE
      if (apiResponse.id === e.id) {
        supplierList.splice(i, 1);
      }
      i++;
    });

    return supplierList;
  };

  executeCRUDLAction = async (crudlStatus, stateVariables) => {
    let supplierRequest = CloudService.BusinessRequest.constructFromObject(
      stateVariables.supplierBean
    );
    if (crudlStatus === CrudlStatus.CREATE) {
      return await this.createSupplier(supplierRequest, stateVariables);
    }
    if (crudlStatus === CrudlStatus.UPDATE) {
      return await this.updateSupplier(supplierRequest, stateVariables);
    }
    if (crudlStatus === CrudlStatus.DELETE) {
      return await this.deleteSupplier(supplierRequest);
    }
  };

  createSupplier = async (supplierRequest, stateVariables) => {
    supplierRequest.codeTag = this.codeTag;
    supplierRequest.userId = this.userId;
    supplierRequest.type = "SUPPLIER";
    let supplierResponse = await ApiService.supplierCreate(supplierRequest);
    if (supplierResponse.errorCode === 0) {
      this.showSuccess("Supplier", CrudlStatus.CREATE);
    } else {
      this.showError("Supplier", CrudlStatus.CREATE);
    }

    return supplierResponse;
  };

  deleteSupplier = async supplierRequest => {
    //RESET PRODUCT REQUEST
    var request = {};
    // request.codeTag = this.codeTag;
    // request.userId = this.userId;
    request.id = supplierRequest.id;
    request.lastUpdatedDateTime = supplierRequest.lastUpdatedDateTime;

    let supplierResponse = await ApiService.supplierDelete(request);
    if (supplierResponse.errorCode === 0) {
      this.showSuccess("Supplier", CrudlStatus.DELETE);
    } else {
      this.showError("Supplier", CrudlStatus.DELETE);
    }

    return supplierResponse;
  };

  updateSupplier = async (supplierRequest, stateVariables) => {
    // supplierRequest.codeTag = this.codeTag;
    // supplierRequest.userId = this.userId;

    let supplierResponse = await ApiService.supplierUpdate(supplierRequest);
    if (supplierResponse.errorCode === 0) {
      this.showSuccess("Supplier", CrudlStatus.UPDATE);
    } else {
      this.showError("Supplier", CrudlStatus.UPDATE);
    }

    return supplierResponse;
  };
}



// WEBPACK FOOTER //
// ./src/components/Supplier/SupplierViewModel.js